import { useAtomValue } from "jotai";
import { useAnnouncementToast as useBaseAnnouncementToast } from "../components";
import { AppState, UserType } from "../types";
import { roomAtom } from "../video-sdk";
import { useGetCurrentProviderQuery } from "./useGetCurrentProviderQuery";

export function useAnnouncementToast() {
  const { data } = useGetCurrentProviderQuery();
  const providerShortId = data?.currentProvider.shortId;
  const isInSession = !!useAtomValue(roomAtom);

  useBaseAnnouncementToast({
    userId: providerShortId,
    userType: UserType.PROVIDER,
    appState: isInSession ? AppState.MEETING : AppState.WAITING,
  });
}
